import { useEffect, useMemo } from 'react'
import { makeStyles } from 'tss-react/mui'
import { useDispatch, useSelector } from 'react-redux'
import { TState } from 'redux/config/root-types'
import { Actions_notificationHistory } from 'redux/modules/notificationHistory/Actions'
import { useNavigate } from 'react-router-dom'
import { To } from 'router/To'
import { Actions_Stations } from 'redux/modules/stations/Actions'
import { Actions_Parkings } from 'redux/modules/parkings/Actions'

const drawerWidth = 477

export const useStationsProblemDrawer = () => {
  const isShowStationsDrawer = useSelector(
    ({ notificationHistory }: TState) => notificationHistory.isShowStationsDrawer,
  )
  const isLoading = useSelector(({ notificationHistory }: TState) => notificationHistory.isLoading)
  const problems = useSelector(({ notificationHistory }: TState) => notificationHistory.problems)
  const filter = useSelector(({ stations }: TState) => stations.filter)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const onClose = () => {
    dispatch(Actions_notificationHistory.store.hideStationsDrawer())
  }

  const onClickOpen = () => {
    dispatch(Actions_notificationHistory.store.hideStationsDrawer())
    dispatch(Actions_Parkings.store.changeStartPage(1))
    dispatch(
      Actions_Stations.store.changeFilter({ lock: 'LOCK_NOT_CLOSED', stationStatus: [{ id: 3 }], connection: null }),
    )
    navigate(To.parkingShowListTable)
  }

  const { classes } = useStyles()

  const data = useMemo(() => problems, [problems])

  return {
    classes,
    data,
    isShowStationsDrawer,
    isLoading,
    onClose,
    onClickOpen,
  }
}

const useStyles = makeStyles()((theme) => ({
  drawerPaper: {
    width: drawerWidth,
    zIndex: 1201,
    borderRadius: '10px 0 0 10px',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '24px 24px 12px',
  },
  closeIcon: {
    marginLeft: 10,
    cursor: 'pointer',
  },
  content: {
    overflowY: 'auto',
    paddingLeft: 24,
    justifyContent: 'space-between',
    height: '100%',
  },
  loader: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  button: {
    margin: 4,
  },
  buttons: {
    marginTop: 24,
  },
}))
